import React, { Component } from 'react'

import classes from './EditModal.scss'

import { connect } from 'react-redux'

import {
    checkValidity,
    getNumericValue,
    // getSelectvalue,
    // updateFilterOptions,
    updateObject,
    updateFormOptions
} from '../../../../../helpers/utils'

import Spinner from '../../../../../components/UI/Spinner/Spinner'
import Modal from '../../../../../components/UI/Modal/Modal'
import Form from './Form/Form'
import Footer from '../../../../../components/UI/Modal/Footer/Footer'
import { withTranslate } from 'react-redux-multilingual'

class EditModal extends Component {
    state = {
        formValid: false,
        inputGroups: {
            structure_id: {
                label: this.props.translate('structure'),
                elementType: 'newselect',
                elementConfig: {
                    type: 'text',
                    placeholder: this.props.translate('select') + this.props.translate('structure'),
                    options: [
                        { value: '', label: this.props.translate('select') + this.props.translate('structure') }
                    ]
                },
                value: {},
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                error: null
            },
            score_name: {
                label: this.props.translate('competencyScore'),
                elementType: 'input',
                elementConfig: {
                    placeholder: this.props.translate('competencyScore')
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                error: null
            },
            score: {
                label: this.props.translate('score'),
                elementType: 'input',
                elementConfig: {
                    placeholder: this.props.translate('score'),
                    type: 'number'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                error: null
            }
        },
        // store props as state for re-rendering comparison check
        updateProps: {
            selectedRecord: this.props.selectedRecord,
            structureOptions: this.props.structureOptions
        }
    }

    static getDerivedStateFromProps(props, state) {
        // Check if modal is open without selecting structure (this case might not exist but we better beware)
        let updatedState = {}
        let { updateProps } = state
        const updateOptions = (stateId, propsId, attr) => {
            const inputGroups = state.inputGroups
            const targetLevelItem = inputGroups[stateId]
            let [attrId, attrName, attrPlaceHolder] = attr

            updatedState = updateObject(updatedState, {
                inputGroups: updateObject(inputGroups, {
                    [stateId]: updateFormOptions(
                        props[propsId],
                        targetLevelItem,
                        attrId,
                        attrId,
                        attrName,
                        attrPlaceHolder
                    )
                }),
                updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
            })
        }

        if (props.structureOptions !== updateProps.structureOptions) {
            updateOptions('structure_id', 'structureOptions', [
                'structure_id',
                { code: 'structure_code', name: 'structure_name' },
                'Select Structure'
            ])
        }

        if (props.selectedRecord !== updateProps.selectedRecord) {
            let newFormData = Object.entries(state.inputGroups).reduce((formGroups, form) => {
                let [formKey, formAttrs] = form
                let value = ''
                let valid = false
                let touched = false
                let errorMessage = null
                if (!formAttrs.validation || !formAttrs.validation.required) {
                    valid = true
                }

                if (props.selectedRecord && props.selectedRecord[formKey]) {
                    value = props.selectedRecord[formKey]

                    let { isValid, error } = checkValidity(
                        value,
                        formAttrs.validation,
                        formAttrs.label
                    )
                    if (formKey === 'score') {
                        if (value === '.00') {
                            value = 0
                        } else {
                            value = parseInt(value)
                        }
                    }
                    if (formAttrs.elementType === 'newselect') {
                        value = state.inputGroups[formKey].elementConfig.options.find(
                            res => res.value === value
                        )
                    }
                    valid = isValid
                    errorMessage = error
                }

                const newFormAttrs = {
                    ...formAttrs,
                    value: value,
                    valid: valid,
                    error: errorMessage,
                    touched: touched
                }

                return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
            }, {})
            updatedState = {
                ...updatedState,
                inputGroups: newFormData,
                formValid: true,
                updateProps: {
                    ...updateProps,
                    selectedRecord: props.selectedRecord
                }
            }
        }
        return updatedState
    }

    componentDidUpdate(prevProps) {
        if (prevProps.success !== this.props.success && this.props.success) {
            this.clearForm()
        }
    }

    inputChangeHandler = (formKey, event) => {
        const inputGroup = this.state.inputGroups
        const formItem = inputGroup[formKey]
        let inputValue = ''

        switch (formItem.elementType) {
            case 'textEditor':
                inputValue = event.target.getContent()
                break
            case 'newselect':
                inputValue = event
                break
            case 'checkbox':
                inputValue = formItem.value === 0 ? 1 : 0
                break
            case 'datePicker':
                inputValue = event
                break

            default:
                inputValue = event.target.value
                break
        }

        const { isValid, error } = checkValidity(
            inputValue,
            formItem.validation,
            formItem.label
        )

        const updatedFormItem = {
            ...formItem,
            value: inputValue,
            valid: isValid,
            error: error,
            touched: true
        }
        const updateGroup = updateObject(inputGroup, { [formKey]: updatedFormItem })
        let formIsValid = true
        Object.values(updateGroup).map(attr => {
            return (formIsValid = formIsValid && attr.valid)
        })

        this.setState({
            inputGroups: updateObject(this.state.inputGroups, { [formKey]: updatedFormItem }),
            formValid: formIsValid
        })
    }

    clearForm = () => {
        if (this.props.action === 'delete') return
        let form = { ...this.state.inputGroups }

        Object.entries(form).forEach(formItem => {
            let [formKey, formAttr] = formItem
            let value = ''
            let valid = true

            if (['datePicker', 'newselect'].includes(formAttr.elementType)) {
                value = null
            }

            if (formAttr.elementType === 'checkbox') {
                value = false
            }

            if (formAttr.validation.required) {
                valid = false
            }

            if (formAttr.elementType === 'formula') {
                value = ''
            }

            if (formAttr.elementType === 'newmultiSelect') {
                value = []
            }

            form[formKey] = { ...formAttr, value: value, valid: valid, touched: false }
        })
        this.props.onHide()
        this.setState({
            inputGroups: form,
            formValid: false
        })
    }

    modalCloseHandler = () => {
        if (this.props.action === 'edit') {
            this.clearForm()
        }
        this.props.onHide()
    }

    formSubmitHandler = type => {
        // e.preventDefault()

        let formData = Object.entries(this.state.inputGroups).reduce((formData, formEntry) => {
            let [formKey, formAttrs] = formEntry

            let value = ''
            if (formAttrs.elementType === 'newselect') {
                value = formAttrs?.value?.value
            } else {
                value = formAttrs.value
            }

            if (formAttrs.validation.isNumeric) {
                value = getNumericValue(value)
            }

            return { ...formData, [formKey]: value }
        }, {})

        this.props.onSave({ ...formData }, type)
        this.clearForm()
    }

    formulaSelectChangeHandler = (structureKey, formKey, value) => {
        structureKey = `${structureKey}`
        this.setState({
            ...this.state,
            [structureKey]: {
                ...this.state[structureKey],
                [formKey]: {
                    ...this.state[structureKey][formKey],
                    formulaSelectValue: value
                }
            }
        })
    }

    render() {
        const { loading, action, open } = this.props
        const {
            formValid,
            inputGroups
        } = this.state


        let formDisplay = <Spinner />
        let formGroup = null

        formGroup = (
            <Form
                form={inputGroups}
                inputChanged={(formKey, e) => this.inputChangeHandler(formKey, e)}
                formulaSelectChanged={(formKey, value) =>
                    this.formulaSelectChangeHandler('competencyScore', formKey, value)
                }
            />
        )

        if (!loading) {
            formDisplay = formGroup
        }

        return (
            <Modal
                open={open}
                onHide={this.modalCloseHandler}
                header={this.props.translate(action) + this.props.translate('competencyScore')}
                backdropClicked={this.modalCloseHandler}
                footer={
                    <Footer
                        save={() => this.formSubmitHandler('save')}
                        another={() => this.formSubmitHandler('saveAno')}
                        showAnother={this.props.action === 'add'}
                        cancel={this.clearForm}
                        disable={!formValid}
                    />
                }>
                <div className={classes.ModalBody}>{formDisplay}</div>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedRecord: state.competencyScore.selectedRecordScore,
        structureOptions: state.competencyScore.filterStructure,
        loading: state.competencyScore.modalLoading || state.competencyScore.selectedRecordLoading,
        success: state.competencyScore.saved
    }
}

export default connect(mapStateToProps)(withTranslate(EditModal))
